var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"width":600,"title":"创建相册"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('AlbumForm',{on:{"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }